import {Map} from '@gongxigames/framework/core/types';
import {ObjectBuilder} from '@gongxigames/framework/core/services/ObjectBuilder';
import {Container, Sprite} from 'pixi.js';
import {AUTOMATION_META, AutomationMeta} from '@gongxigames/framework/core/fragments/Autotest';

export class BitmapText extends Container {
    protected static POOL: Map<Map<Sprite[]>> = {};

    protected static CHAR_MAP: {[char: string]: string;} = {
        $: 'usd',
        '€': 'eur',
        '¥': 'cny',
        '.': 'dot',
        ',': 'comma'
    };

    protected _text!: string;
    protected _textSpriteName: string;
    protected _textSpritePrefix?: string;
    protected _objectBuilder: ObjectBuilder;
    protected _space?: number;

    constructor(textSpriteName: string, objectBuilder: ObjectBuilder, space?: number, prefix?: string) {
        super();

        this._textSpriteName = textSpriteName;
        this._textSpritePrefix = prefix;
        this._objectBuilder = objectBuilder;
        this._space = space;
    }

    public get text(): string {
        return this._text;
    }

    public set text(value: string) {
        let x = 0;
        let space = this._space;

        this.storeInPool();
        this.removeChildren();

        for (const c of value) {
            const displayObject = this.getDisplayObject(c);

            displayObject.x = x;
            x += displayObject.width;

            if (space === undefined) {
                space = displayObject.width / 10;
            }

            x += space;

            this.addChild(displayObject);
        }

        this._text = value;
    }

    protected getDisplayObject(c: string): Sprite {
        if (BitmapText.POOL[this._textSpriteName] && BitmapText.POOL[this._textSpriteName][c] &&
            BitmapText.POOL[this._textSpriteName][c].length > 0) {
            return BitmapText.POOL[this._textSpriteName][c].pop()!;
        }

        if (BitmapText.CHAR_MAP[c]) {
            c = BitmapText.CHAR_MAP[c];
        }

        return this._objectBuilder.buildDisplayObjectByName(this._textSpriteName, c, this._textSpritePrefix) as Sprite;
    }

    protected storeInPool(): void {
        if (!this._text) {
            return;
        }

        for (let i = 0; i < this._text.length; i++) {
            const c = this._text[i];

            if (!BitmapText.POOL[this._textSpriteName]) {
                BitmapText.POOL[this._textSpriteName] = {};
            }

            if (!BitmapText.POOL[this._textSpriteName][c]) {
                BitmapText.POOL[this._textSpriteName][c] = [];
            }

            BitmapText.POOL[this._textSpriteName][c].push(this.getChildAt(i) as Sprite);
        }
    }

    [AUTOMATION_META](): AutomationMeta {
        return {
            type: 'text',
            text: this.text
        };
    }
}
